import { Variable } from '@ff-scene-plugins/gift-shared/Variable';
import { engravingToFfCanvas } from '@gift-variable-plugins/engraving-shared/engravingToFfCanvas';
import { EngravingVariableInput } from '@gift-variable-plugins/engraving-shared/EngravingVariableInput';
import { EngravingVariableOptions } from '@gift-variable-plugins/engraving-shared/EngravingVariableOptions';
import { EngravingInputControl } from './EngravingInputControl';

export const engravingPdpPlugin: Variable.Plugin<EngravingVariableOptions, EngravingVariableInput> = {
    pluginId: 'engraving',
    InputControl: EngravingInputControl,
    toFfCanvas: engravingToFfCanvas
};